"use client";
import ReactSelect, { GroupBase, Props } from "react-select";

import { ClearIndicator, DropdownIndicator, ValueContainer, NoOptionsMessage } from "./form/CustomSelectComponents";


export function DropdownSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({ styles, className, classNames, components, ...props }: Props<Option, IsMulti, Group>) {


  return (
    <ReactSelect
      {...props}
      components={{
        ClearIndicator, DropdownIndicator, ValueContainer, NoOptionsMessage, IndicatorSeparator: () => null,
        ...components,
      }}
      instanceId={props.id} // https://github.com/JedWatson/react-select/issues/5459
      className={`dropdown-select ${className || ""}`}
      classNamePrefix="dropdown-select"
      classNames={{
        ...classNames,
        control: ({isFocused}) =>
        `${classNames?.control || ""} ${
          isFocused
            ? ""
            : ""
        }`,
        dropdownIndicator: () => "text-gray-900",
      }}
      styles={{
        ...styles,
        control: () => ({}),
      }}
    />
  );
}
